import { useState } from 'react';
import type { CurrencyProfile } from '@tg/shared';

/** Built-in currency mark, or an uploaded PNG. Slot symbols and decorative game art are separate. */
export function CurrencyIcon({
  profile,
  size = 24,
  className,
}: {
  profile: CurrencyProfile;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  if (profile.icon === 'custom' && profile.image && failed !== profile.image)
    return (
      <img
        src={profile.image}
        width={size}
        height={size}
        className={className}
        alt=""
        aria-hidden="true"
        draggable={false}
        onError={() => setFailed(profile.image)}
        style={{ objectFit: 'contain', flex: 'none', verticalAlign: 'middle' }}
      />
    );
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
      style={{ flex: 'none', verticalAlign: 'middle' }}
    >
      <circle cx="16" cy="16" r="15" fill="#087e6b" stroke="#71f1cf" />
      <text
        x="16"
        y="22"
        textAnchor="middle"
        fill="#fff"
        fontFamily="Arial, sans-serif"
        fontWeight="700"
        fontSize="19"
      >
        {profile.icon === 'usdt' ? '₮' : profile.ticker[0]}
      </text>
    </svg>
  );
}
